import React from 'react';
import {
  List,
  Button,
  Card,
  Typography,
  Row,
  Col,
} from 'antd';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { convertToAnyFormat } from '@helpers/index';
import { useTranslation } from 'react-i18next';
import { NotificationListProps } from './types';

const NotificationList = ({ notifications, onMarkAsRead }:NotificationListProps) => {
  const { Text } = Typography;
  const { t } = useTranslation();
  return (
    <List
      itemLayout="vertical"
      dataSource={notifications}
      className="max-h-[400px] overflow-y-auto"
      renderItem={(notification) => (
        <List.Item key={notification.id} className="pb-2">
          <Card
            style={{ backgroundColor: '#e5f7fb' }}
            className="hover:!bg-cyan-700 text-white transition-all"
          >
            <Row justify="end" gutter={[0, 8]}>
              <Col>
                <Text type="secondary" className="text-xs">
                  {convertToAnyFormat(notification.createdAt as string, 'DD MMM YYYY HH:mm')}
                </Text>
              </Col>
            </Row>
            <Row gutter={[0, 8]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  className="markdown-content text-gray-600"
                >
                  {notification.content}
                </ReactMarkdown>
              </Col>
            </Row>
            <Row justify="end">
              <Col>
                <Button
                  type="primary"
                  size="middle"
                  className="bg-blue-900 hover:bg-blue-700 font-medium border-none rounded-lg"
                  onClick={() => onMarkAsRead({ id: notification.id, seen: true })}
                >
                  {t('notification.markAsRead')}
                </Button>
              </Col>
            </Row>
          </Card>
        </List.Item>

      )}
    />
  );
};

export default NotificationList;
